/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC, useMemo } from 'react';

import { Card, LinearProgress, Stack, Typography } from '@mui/material';
import { Control } from 'react-hook-form';

import FilterWithSearch from './FilterWithSearch';
import CheckboxButtonGroup from '../../../components/CheckboxButtonGroup';
import ListSkeleton from '../../../components/ListSkeleton';
import { propertyExists } from '../../../components/utils';
import CheckBoxFilled from '../../../Icons/CheckFilled';
import { filterHeaderStyle, scrollContainerSx } from '../../Filter/StaticData';

interface IProps {
  control: Control;
  insightsData: any;
  isLoading: boolean;
  ClauseTypeMap: any;
}

const ClauseTypeFilter: FC<IProps> = ({
  control,
  insightsData,
  isLoading,
  ClauseTypeMap,
}) => {
  const clauseTypeData = useMemo(() => {
    const clauses: any = [];
    if (insightsData) {
      if (propertyExists(insightsData, 'clause_type') && ClauseTypeMap) {
        const data: any = [];
        for (const key in insightsData['clause_type']) {
          const newObj = {
            label: key,
            count: insightsData['clause_type'][key].present,
          };
          data.push(newObj);
        }
        data?.map((item: any) => {
          const updatedData = {
            ...item,
            label: ClauseTypeMap[item.label] || item.label,
            index: item.label,
          };
          clauses.push(updatedData);
        });
      }
    }
    return clauses;
  }, [insightsData, ClauseTypeMap]);

  return (
    <Stack gap={2}>
      <Card>
        <Typography sx={filterHeaderStyle}>Clause Type</Typography>
        {!isLoading ? (
          <Stack gap={1} sx={scrollContainerSx}>
            <CheckboxButtonGroup
              name="clause_type"
              control={control}
              options={clauseTypeData}
              valueKey="index"
              checkBoxProps={{
                checkedIcon: (
                  <CheckBoxFilled style={{ fill: 'none !important' }} color="#88305F" />
                ),
              }}
              returnObject
              renderCustomComponent={(value) => (
                <LinearProgress
                  variant="determinate"
                  sx={{
                    background: 'transparent',
                    borderBottom: '1px solid #D1D3D4',
                  }}
                  value={(value / insightsData.total) * 100}
                />
              )}
              labelProps={{
                sx: {
                  padding: '2px 2px 2px 10px',
                },
              }}
            />
          </Stack>
        ) : (
          <ListSkeleton numberOfLines={6} />
        )}
      </Card>
      <FilterWithSearch
        label="Contract Type"
        control={control}
        filterData={insightsData}
        clause="contract_type"
        propertyKey="contract_type_counts"
      />
      <FilterWithSearch
        label="Groups"
        control={control}
        filterData={insightsData}
        clause="groups"
        propertyKey="groups_counts"
      />

      <FilterWithSearch
        label="Projects"
        control={control}
        filterData={insightsData}
        clause="projects"
        propertyKey="projects_counts"
      />
      <FilterWithSearch
        label="Lender Details"
        control={control}
        filterData={insightsData}
        clause="lender_details"
        propertyKey="lender_details_count"
      />
      <FilterWithSearch
        label="Borrower Details"
        control={control}
        filterData={insightsData}
        clause="borrower_details"
        propertyKey="borrower_details_counts"
      />
    </Stack>
  );
};

export default ClauseTypeFilter;
